var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("truncate", {
    staticClass:
      "ds-caption--size_1xs ds-caption--size_md-md ds-caption--w_r ds-caption--h_xs read_more ds-caption ds-caption--c_blue ds-caption--h_sm-xl",
    attrs: {
      clamp: _vm.clamp,
      length: _vm.width,
      less: _vm.less,
      text: _vm.text,
      type: "html"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e4e6685", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e4e6685","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/app/UiElements/ReadMore.vue
// module id = 96
// module chunks = 0